module.exports = __webpack_public_path__ + "img/translate7.9900dabf.jpg";